'use client'

import { Backdrop, CircularProgress, Container } from '@mui/material'
import { useParams, usePathname, useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useCompanyContext } from '../context/CompanyContext'
import { useUserContext } from '../context/UserContext'
import { UserRole } from '@/constants/enums'

export const dynamic = 'force-dynamic'

const Page = () => {
    const router = useRouter()
    const { hasNoUser, roles, isUserLoading } = useUserContext()
    const { company } = useCompanyContext()
    const { companySlug } = useParams<{ companySlug: string }>()

    useEffect(() => {
        if (!isUserLoading) {
            if (hasNoUser) {
                router.push('/')
            } else if (company && company?.companySlug === companySlug && roles?.length > 0) {
                if (roles?.includes(UserRole.SuperAdmin)) {
                    router.push(`/panel/organizations`)
                } else {
                    router.push(`/${companySlug}/recruitment/jobs/myJobs`)
                }
            }
        }
    }, [company, companySlug, roles, hasNoUser, isUserLoading])

    return (
        <Container>
            <Backdrop sx={{ color: '#fff', zIndex: 1600 }} open={isUserLoading}>
                <CircularProgress color="primary" />
            </Backdrop>
        </Container>
    )
}

export default Page
